import domain from '@framework/config/domain';
import config from '@finsight/config';
import buildUrl from '@framework/url/helpers/buildUrl';

export const getUrl = (...uris: (string | string[])[]): string => {
  return buildUrl(domain.protocol, config.hostname, ...uris);
};
